import { Component, OnInit } from '@angular/core';
import { EditorInputField, Site } from '../../../../editor-container/editor-model';

@Component({
  selector: 'kve-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.scss']
})
export class TypographyComponent implements OnInit {
  fields:EditorInputField[] = [
    {
      name:"fontFamilyPrim",
      title:"Primary Font Family",
      type:"theme",
      controlType:"font"
    },
    {
      name:"fontFamilySec",
      title:"Secondary Font Family",
      type:"theme",
      controlType:"font"
    }/* ,
    {
      name:"",
      title:"",
      type:"",
      controlType:""
    },
    {
      name:"",
      title:"",
      type:"",
      controlType:""
    },
    {
      name:"",
      title:"",
      type:"",
      controlType:""
    },
    {
      name:"",
      title:"",
      type:"",
      controlType:""
    } */
  ]
  constructor() { }

  ngOnInit(): void {
  }

}

/* text-heading-1-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-1-font-size	2.25rem	
text-heading-1-font-weight	700	
text-heading-1-line-height	3rem	
text-heading-2-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-2-font-size	2rem	
text-heading-2-font-weight	700	
text-heading-2-line-height	2.5rem	
text-heading-3-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-3-font-size	1.875rem	
text-heading-3-font-weight	700	
text-heading-3-line-height	2.5rem	
text-heading-4-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-4-font-size	1.625rem	
text-heading-4-font-weight	700	
text-heading-4-line-height	2rem	
text-heading-5-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-5-font-size	1.375rem	
text-heading-5-font-weight	700	
text-heading-5-line-height	2rem	
text-heading-6-font-family	Open Sans, sans-serif	font-family-secondaryfont-family-primary
text-heading-6-font-size	1.125rem	
text-heading-6-font-weight	700	
text-heading-6-line-height */
